import React, { useCallback, useContext, useMemo } from 'react';
import { Icon, StudioMenu, type StudioMenuOption } from 'venn-ui-kit';
import { type Page, StudioContext, UserContext } from 'venn-components';
import { PageType } from 'venn-utils';
import { PanelHeader } from './PanelHeader';

const PAGE_OPTIONS: StudioMenuOption<Page>[] = [
  {
    label: 'New Page',
    value: {
      type: PageType.GRID,
      layout: [],
    },
  },
  {
    label: 'New Title Page',
    value: {
      type: PageType.TITLE,
      layout: [],
      titleSettings: {
        title: '',
        subTitle: '',
        additionalText: '',
      },
    },
  },
  {
    label: 'New Section Page',
    value: {
      type: PageType.SECTION,
      layout: [],
      sectionSettings: {
        topText: '',
        title: '',
        subTitle: '',
      },
    },
  },
  {
    label: 'New Disclosure Page',
    value: {
      type: PageType.DISCLOSURE,
      layout: [],
    },
  },
];

const NewPageButton = () => {
  const { hasPermission } = useContext(UserContext);
  const { onAddNewPage } = useContext(StudioContext);

  const canUserAddPages = hasPermission('STUDIO_INSERT_BLOCKS');

  const onSelect = useCallback((option: Page) => onAddNewPage(option), [onAddNewPage]);

  const buttonContent = (
    <>
      New
      <Icon type="caret-down" className="text-[12px] font-black leading-none pl-1" />
    </>
  );

  const menuOptions = useMemo(
    () => PAGE_OPTIONS.map((option) => ({ ...option, disabled: !canUserAddPages })),
    [canUserAddPages],
  );

  return (
    <PanelHeader.Root>
      <PanelHeader.Text>Pages</PanelHeader.Text>
      <div className="relative w-full flex justify-end">
        <StudioMenu
          label="New Page"
          size="medium"
          options={menuOptions}
          onSelect={onSelect}
          buttonContent={buttonContent}
          itemClassName="text-left"
        />
      </div>
    </PanelHeader.Root>
  );
};

export default NewPageButton;
